import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/home";

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="w-full bg-primary-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="观众口碑"
          title="追剧的人怎么说"
          desc="来自正在追《黑料短剧》的观众反馈，看看档案馆在哪些环节真正帮上了忙。"
          align="center"
          accent="primary"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-primary-200 bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-primary-500">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{item.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="font-heading text-sm font-bold text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.tag}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}